import { ANSWER_LANGUAGES, AnswerLanguage } from '@glow/ai-contract'
import i18next from 'i18next'

// Per user, since terminal PCs are shared and the drawer is keyed on the user
const storageKey = (userId: number) => `aiChat.language.${userId}`

// The app registers Danish as dk, and browser detection can leave a regional code such as nb-NO
export const answerLanguageOf = (language: string | undefined): AnswerLanguage => {
  const base = language?.split('-')[0]
  const code = base === 'dk' ? 'da' : base
  return ANSWER_LANGUAGES.find((supported) => supported === code) ?? 'en'
}

export const appAnswerLanguage = (): AnswerLanguage => answerLanguageOf(i18next.resolvedLanguage ?? i18next.language)

// A choice holds while the app stays in the language it was made under; switching the app's language moves the chat too
export const readAnswerLanguage = (userId: number): AnswerLanguage => {
  const app = appAnswerLanguage()
  const stored = globalThis.localStorage.getItem(storageKey(userId))
  const [madeUnder, chosen] = (stored ?? '').split(':')
  if (madeUnder === app) {
    return ANSWER_LANGUAGES.find((language) => language === chosen) ?? app
  }
  // Dropped, so switching Glow back to that language later does not bring the old choice back
  if (stored !== null) {
    globalThis.localStorage.removeItem(storageKey(userId))
  }
  return app
}

export const storeAnswerLanguage = (userId: number, language: AnswerLanguage) =>
  globalThis.localStorage.setItem(storageKey(userId), `${appAnswerLanguage()}:${language}`)
